import React from "react";
import style from "./SuccessStories.module.css";
import Header from "../../components/Header";
import HeaderMobile from "../../components/HeaderMobile";
import TestimonialContainer from "../TestimonialContainer/index.jsx";
import IndustrySlideShow from "../IndustrySlideShow";
import FeaturedBlog from "../../components/FeaturedBlog/index.jsx";
import TopTalentCard from "../../components/TopTalentCard/index.jsx";
import UnlockingPotentialCard1 from "../../components/UnlockingPotentialCard1/index.jsx";
import UnlockingPotentialCard2 from "../../components/UnlockingPotentialCard2/index.jsx";

import div1_img from "../../assets/UnlockingPotential/div1_img.png";
import div3_img from "../../assets/UnlockingPotential/div3_img.png";
import div5_img from "../../assets/UnlockingPotential/div5_img.png";
import div7_img from "../../assets/UnlockingPotential/div7_img.png";
import div9_img from "../../assets/UnlockingPotential/div9_img.png";

import div2_img from "../../assets/UnlockingPotential/div2_img.png";
import div4_img from "../../assets/UnlockingPotential/div4_img.png";
import div6_img from "../../assets/UnlockingPotential/div6_img.png";
import div8_img from "../../assets/UnlockingPotential/div8_img.png";
import div10_img from "../../assets/UnlockingPotential/div10_img.png";
import { successStoryBg } from "../../assets/index.js";
import { Clients2 } from "../Clients2/index.jsx";



export default function SuccessStories() {

    const UnlockingPotentialArray = [
        {
            sno: "01",
            image: div1_img,
            heading: "KYC - Know Your Client",
            content: " Understanding your goals, culture, and role expectations."
        }, 
        {
            sno: "02",
            image: div2_img,
            heading: "Job Role Specification",
            content: "Crafting detailed job descriptions tailored to your hiring needs."
        },
        {
            sno: "03",
            image: div3_img,
            heading: "Targeted Talent Search",
            content: "Sourcing active and passive candidates from multiple talent pools."
        },
        {
            sno: "04",
            image: div4_img,
            heading: "Evaluation & Shortlist",
            content: "Filtering profiles using skill-match and behavioral alignment."
        },
        {
            sno: "05",
            image: div5_img,
            heading: "Assessments",
            content: "Custom assessments to validate technical and soft skills."
        },
        {
            sno: "06",
            image: div6_img,
            heading: "Pre-Screen Interviews",
            content: " First-level interviews by NuFolks to refine the shortlist."
        },
        {
            sno: "07",
            image: div7_img,
            heading: "FoxMatrix Interview Assessments",
            content: "We leverage FoxMatrix to conduct expert-led, role-specific evaluations."
        },
        {
            sno: "08",
            image: div8_img,
            heading: "Reference Check",
            content: "Verifying past performance and credentials."
        },
        {
            sno: "09",
            image: div9_img,
            heading: "Offer & Negotiation",
            content: "Assisting in closing offers and managing expectations."
        },
        {
            sno: "10",
            image: div10_img,
            heading: "Onboarding Assistance",
            content: "Helping new hires hit the ground running from Day 1."
        }
    ]

    return(

        <div className={style.SuccessStories_container}>

            <HeaderMobile />

            <div className={style.dashboard}>
                
                <Header />
            
                <img src={successStoryBg} alt="background image" />

                <div className={style.content_container}>
                    <p data-aos="fade-left" data-aos-duration="2000">Success Starts with the Right People.</p>
                    <p data-aos="fade-right" data-aos-duration="2000">We fuel business growth with strategic staffing and tailored hiring solutions. From tech to retail, our smart sourcing, agile screening, and seamless onboarding help companies build teams that truly fit.</p>
                </div>

            </div>

            {/* <Industry /> */}
            <IndustrySlideShow />

            {/* <SuccessStoriesClients /> */}
            <div style={{height: "4rem", backgroundColor: "white"}}> </div>
            <Clients2 headingText="Trusted by Industry Leaders" subText="We partner with top global brands across tech, finance, healthcare, and more—delivering skilled talent and agile hiring solutions that scale success." />

            {/* UnLocking Potential */}
            <div className={style.UnlockingPotential_outer}>    
                <div className={style.UnlockingPotential_container}>
                    <div className={style.UnlockingPotential_content}>
                        <p>Unlocking Potential: Talent Sourcing & Onboarding</p>
                        <p>NuFolks has re-invented the traditionally run of the mill staffing process to a well-oiled machinery with a strong emphasis on candidate filtering, ensuring a superior client experience and saving clients valuable time.</p>
                    </div>
                    {
                        Array.from({length: UnlockingPotentialArray.length}).map((_, index) => (
                            
                            <>
                                {
                                    index % 2 === 0 || index === 0
                                        ?
                                    <UnlockingPotentialCard1 
                                        sno={UnlockingPotentialArray[index].sno} 
                                        image={UnlockingPotentialArray[index].image} 
                                        heading={UnlockingPotentialArray[index].heading} 
                                        content={UnlockingPotentialArray[index].content} 
                                    />
                                        :
                                    <UnlockingPotentialCard2
                                        sno={UnlockingPotentialArray[index].sno} 
                                        image={UnlockingPotentialArray[index].image} 
                                        heading={UnlockingPotentialArray[index].heading} 
                                        content={UnlockingPotentialArray[index].content} 
                                    />
                                }   
                            </>
                        ))
                    }
                </div>
            </div>

            <TestimonialContainer heading="What Our Clients Say About Us" isSubHeading={false} isEmployeeTestimonial={false} />

            <FeaturedBlog />

            <div className={style.TopTalent_outer_Container}>
                <TopTalentCard heading="Let’s Build Careers, Together" content="Looking for growth-driven opportunities or the right talent to elevate your team? At NuFolks, we make meaningful connections happen. Drop your CV or hire top-notch talent today — because great teams build great futures." cardBGColor="#12151D" hColor="white" pColor= "white" />
            </div>            

        </div>
    );
}
